import type { en } from './en.js';

export const ar: Record<keyof typeof en, string> = {
  'app.name': 'numsLearn',
  'app.tagline': 'طابِق الأرقام. تصدَّر الصف.',

  'nav.play': 'اللعب',
  'nav.admin': 'المعلّم',

  'hud.time': 'الوقت', 'hud.score': 'النقاط', 'hud.combo': 'التتابع',
  'hud.left': 'المتبقّي', 'hud.adds': 'الإضافات', 'hud.hints': 'المساعدات',

  'btn.add': 'أضف صفًا', 'btn.hint': 'مساعدة', 'btn.restart': 'لوحة جديدة',
  'btn.close': 'إغلاق', 'btn.done': 'تم', 'btn.reset': 'العودة لإعدادات المستوى',

  'rule.equal': 'اضغط رقمين متساويين',
  'rule.sumTo': 'اضغط رقمين مجموعهما {n}',
  'rule.sumTo20': 'اضغط رقمين مجموعهما {n}',
  'rule.multipleOf': 'اضغط رقمًا وأحد مضاعفاته',
  'rule.sameProduct': 'اضغط عمليتين ناتجهما واحد',
  'rule.equivalent': 'اضغط مقدارين متكافئين',

  'level.gentle': 'هادئ', 'level.steady': 'ثابت', 'level.brisk': 'سريع',
  'level.sharp': 'حادّ', 'level.fierce': 'شرس',

  'theme.playground': 'الملعب',
  'theme.playground.desc': 'أقراص ملوّنة على خوخي دافئ. نابضة ومتسامحة — الأفضل للصفوف الأولى.',
  'theme.paper': 'الورقة والقلم',
  'theme.paper.desc': 'أزرق حبر على ورق مسطّر. قلم أحمر يرسم خطًا فوق كل زوج.',
  'theme.clay': 'الطين الناعم',
  'theme.clay.desc': 'طين باستيلي سميك وملموس ينضغط مع كل ضغطة.',
  'theme.auto': 'حسب الصف',
  'theme.auto.desc': 'الملعب للصفين ١-٢، الطين للصفوف ٣-٤، الورقة للصفوف ٥-٦.',

  'msg.cleared': 'اكتملت اللوحة!',
  'msg.timeUp': 'انتهى الوقت',
  'msg.noMoves': 'لا حركات متاحة — أضف صفًا',
  'msg.grade': 'الصف {g}',
  'msg.level': 'المستوى {n}',
  'msg.match': '{a} + {b} = {t}',
  'msg.matchEq': '{a} = {b}',
  'msg.noMatch': '{a} + {b} ≠ {t}',
  'msg.noMatchEq': '{a} ≠ {b}',
  'msg.notConnected': '{a} و{b} غير متّصلين',

  'admin.title': 'لوحة المعلّم',
  'admin.subtitle': 'كل ما تفعله اللعبة، بين يديك.',
  'admin.theme': 'المظهر والإحساس',
  'admin.themeHelp': 'اختر العالم الذي يلعب فيه الصف. يُطبَّق فورًا.',
  'admin.appearance': 'المظهر',
  'admin.mode': 'الإضاءة', 'admin.modeLight': 'فاتح', 'admin.modeDark': 'داكن', 'admin.modeAuto': 'تلقائي',
  'admin.lang': 'اللغة', 'admin.numerals': 'الأرقام',
  'admin.sound': 'المؤثّرات الصوتية',
  'admin.soundHelp': 'مطفأة افتراضيًا — ثلاثون جهازًا تصدر أصواتًا معًا كثير على الصف. شغّلها على شاشة العرض.',
  'admin.numLatin': '0–9', 'admin.numArabic': '٠–٩',
  'admin.content': 'الدرس',
  'admin.grade': 'السنة الدراسية', 'admin.sublevel': 'المستوى',
  'admin.rules': 'القواعد', 'admin.rule': 'قاعدة المطابقة', 'admin.target': 'المجموع المطلوب',
  'admin.board': 'اللوحة', 'admin.rows': 'الصفوف', 'admin.cols': 'الأعمدة',
  'admin.range': 'مدى الأرقام', 'admin.min': 'الأصغر', 'admin.max': 'الأكبر',
  'admin.digits': 'عدد الخانات',
  'admin.adjacency': 'اشتراط اتصال المربعات',
  'admin.adjacencyHelp': 'مُعطَّل للصفين ١-٢: لا ينبغي منع الصغار لسبب مكاني. مُفعَّل من الصف ٣ حيث يصبح هو اللغز.',
  'admin.timer': 'مؤقّت الجولة (ثانية)', 'admin.timerOff': 'بلا مؤقّت',
  'admin.adds': 'عدد الإضافات المسموحة', 'admin.hints': 'عدد المساعدات',
  'admin.penalty': 'النقاط المخصومة لكل خطأ',
  'admin.solvable': 'استخدم اللوحات القابلة للحل بالكامل فقط',
  'admin.equalMultiples': 'اسمح بمطابقة الرقم مع مثله',
  'admin.oneFactor': 'اسمح للرقم ١ بمطابقة كل شيء',
  'admin.presets': 'الإعدادات المحفوظة',
  'admin.presetName': 'اسم الإعداد', 'admin.save': 'احفظ', 'admin.load': 'تحميل', 'admin.delete': 'حذف',
  'admin.noPresets': 'لا إعدادات محفوظة بعد.',
  'admin.preview': 'معاينة حيّة',
  'admin.custom': 'مخصّص',
  'admin.presetPlaceholder': 'مثال: تمرين الثلاثاء',
  'admin.presetsServer': 'محفوظة في حسابك — متاحة على أي جهاز.',
  'admin.presetsLocal': 'محفوظة في هذا المتصفح. سجّل الدخول كمعلّم لحفظها في حسابك.',

  'nav.badges': 'الأوسمة',
  'nav.home': 'الرئيسية',
  'nav.practice': 'تدريب',
  'nav.leave': 'خروج',

  'home.blurb': 'طابِق الأرقام قبل انتهاء الوقت. انضم إلى صفّك بالرمز المعروض، أو تدرّب وحدك.',
  'home.joinTitle': 'انضم إلى صفّك',
  'home.joinHint': 'سيقرأ معلّمك رمزًا من ستة أحرف.',
  'home.code': 'رمز الصف',
  'home.go': 'انطلق',
  'home.practiceTitle': 'تدرّب وحدك',
  'home.practiceHint': 'كل السنوات وكل المستويات، بلا حاجة إلى صف.',
  'home.practiceGo': 'ابدأ التدريب',
  'home.teacherTitle': 'أنا معلّم',
  'home.teacherHint': 'أدِر جلسة صفية، وشاهد لوحة الصدارة، واضبط المستويات.',
  'home.teacherGo': 'دخول المعلّم',

  'join.title': 'الانضمام إلى {code}',
  'join.nickname': 'اسمك',
  'join.pin': 'رمزك السري (٤ أرقام)',
  'join.pinHint': 'اختر رمزًا تتذكّره. هو ما يحفظ أوسمتك لك وحدك.',
  'join.go': 'انضم إلى الصف',
  'join.joining': 'جارٍ الانضمام…',
  'join.err.no_session': 'لا توجد جلسة بهذا الرمز الآن.',
  'join.err.bad_pin': 'هذا الاسم مستخدم والرمز السري غير مطابق.',
  'join.err.session_ended': 'انتهت هذه الجلسة.',
  'join.err.invalid': 'تحقّق من الرمز واسمك ورمز سري من أربعة أرقام.',
  'join.err.offline': 'تعذّر الوصول إلى الخادم. تحقّق من الشبكة وأعد المحاولة.',

  'live.lobby': 'بانتظار أن يبدأ معلّمك',
  'live.lobbyHint': 'أنت في الصف. أبقِ الصفحة مفتوحة.',
  'live.countdown': 'استعد…',
  'live.paused': 'أوقف المعلّم الجولة مؤقتًا',
  'live.round': 'الجولة {a} من {b}',
  'live.results': 'نتائج الجولة',
  'live.final': 'الترتيب النهائي',
  'live.ended': 'انتهت الجلسة',
  'live.waitingNext': 'بانتظار الجولة التالية',
  'live.reconnecting': 'إعادة الاتصال…',
  'live.you': 'أنت',
  'live.players': '{n} يلعبون',
  'live.rank': 'الترتيب',
  'live.cleared': 'أكمل',
  'live.leaveAsk': 'هل تريد مغادرة الجلسة؟',

  'host.title': 'جلسة الصف',
  'host.joinAt': 'الانضمام عبر',
  'host.code': 'رمز الصف',
  'host.start': 'ابدأ',
  'host.next': 'الجولة التالية',
  'host.skip': 'أنهِ الجولة',
  'host.pause': 'إيقاف مؤقت',
  'host.resume': 'متابعة',
  'host.end': 'إنهاء الجلسة',
  'host.kick': 'إزالة',
  'host.noPlayers': 'لم ينضم أحد بعد.',
  'host.players': 'اللاعبون',
  'host.lobby': 'الانتظار',
  'host.endAsk': 'هل تنهي الجلسة للجميع؟',
  'host.projector': 'شاشة العرض',

  'teacher.signIn': 'دخول المعلّم',
  'teacher.signUp': 'إنشاء حساب معلّم',
  'teacher.email': 'البريد الإلكتروني',
  'teacher.password': 'كلمة المرور',
  'teacher.name': 'اسمك',
  'teacher.regCode': 'رمز الدعوة',
  'teacher.submitIn': 'دخول',
  'teacher.submitUp': 'إنشاء الحساب',
  'teacher.toSignUp': 'لا حساب لك؟ أنشئ واحدًا',
  'teacher.toSignIn': 'لديك حساب؟ سجّل الدخول',
  'teacher.signOut': 'خروج',
  'teacher.classes': 'صفوفك',
  'teacher.newClass': 'صف جديد',
  'teacher.className': 'اسم الصف',
  'teacher.create': 'إنشاء الصف',
  'teacher.noClasses': 'لا صفوف بعد. أنشئ صفًا للحصول على رمز انضمام.',
  'teacher.students': '{n} طالبًا',
  'teacher.roster': 'الطلاب',
  'teacher.leaderboard': 'لوحة صدارة الصف',
  'teacher.startSession': 'ابدأ جلسة',
  'teacher.mode': 'نوع الجلسة',
  'teacher.lockstep': 'جولات موقوتة',
  'teacher.lockstepHint': 'جولات بوقت محدّد، تتقدّم بالصف معًا.',
  'teacher.race': 'سباق',
  'teacher.raceHint': 'إيقاع حر. أول لوحة تكتمل تفوز بالجولة.',
  'teacher.rounds': 'الجولات',
  'teacher.roundsHint': 'اختر المستويات التي ستُلعب، بالترتيب.',
  'teacher.launch': 'افتح شاشة العرض',
  'teacher.deleteClass': 'حذف الصف',
  'teacher.deleteAsk': 'هل تحذف هذا الصف وطلابه وأوسمتهم؟',
  'teacher.removeStudent': 'إزالة',
  'teacher.removeAsk': 'هل تزيل هذا الطالب؟ ستذهب أوسمته ونقاطه معه.',
  'teacher.live': 'جارية الآن',
  'teacher.err.bad_credentials': 'البريد أو كلمة المرور غير صحيحة.',
  'teacher.err.email_taken': 'يوجد حساب بهذا البريد.',
  'teacher.err.weak_password': 'استخدم ١٠ أحرف على الأقل.',
  'teacher.err.registration_closed': 'التسجيل مغلق على هذا الخادم.',
  'teacher.err.bad_registration_code': 'رمز الدعوة غير صحيح.',
  'teacher.err.bad_email': 'تحقّق من البريد الإلكتروني.',
  'teacher.err.bad_name': 'أدخل اسمك.',
  'teacher.err.generic': 'حدث خطأ. أعد المحاولة.',
  'teacher.badges': 'الأوسمة',
  'teacher.score': 'النقاط',
  'teacher.streak': 'التتابع',
  'teacher.copy': 'نسخ الرابط',
  'teacher.copied': 'تم النسخ',

  'rule.productTo': 'اضغط رقمين حاصل ضربهما {n}',
  'rule.even': 'اضغط كل عدد زوجي',
  'rule.odd': 'اضغط كل عدد فردي',
  'rule.prime': 'اضغط كل عدد أوّلي',
  'rule.notPrime': 'اضغط كل عدد غير أوّلي',
  'rule.multiplesOf': 'اضغط كل مضاعفات {n}',
  'rule.factorsOf': 'اضغط كل عوامل {n}',
  'topic.even': 'الأعداد الزوجية',
  'topic.odd': 'الأعداد الفردية',
  'topic.mult2': 'مضاعفات ٢',
  'topic.multN': 'مضاعفات عدد',
  'topic.factors': 'عوامل عدد',
  'topic.prime': 'الأعداد الأوّلية',
  'topic.notPrime': 'الأعداد غير الأوّلية',
  'topic.product12': 'حاصل الضرب ١٢',
  'topic.productN': 'حاصل ضرب عدد',
  'hud.found': 'وجدت',
  'msg.found': '{a} — بقي {n}',
  'msg.foundAll': 'وجدتها كلها!',
  'msg.notEven': '{a} ليس زوجيًا',
  'msg.notOdd': '{a} ليس فرديًا',
  'msg.notPrimeMiss': '{a} ليس أوّليًا',
  'msg.isPrimeMiss': '{a} عدد أوّلي',
  'msg.notMultiple': '{a} ليس من مضاعفات {t}',
  'msg.notFactor': '{a} ليس من عوامل {t}',
  'msg.matchFactor': '{a} × {k} = {b}',
  'msg.matchDivide': '{b} ÷ {a} = {k}',
  'msg.noMatchMultiple': '{a} ليس من مضاعفات {b}',
  'msg.matchProduct': '{a} × {b} = {t}',
  'msg.noMatchProduct': '{a} × {b} ≠ {t}',
  'praise.1': 'أحسنت!',
  'praise.2': 'ممتاز!',
  'praise.3': 'رائع!',
  'praise.4': 'واصِل!',
  'praise.5': 'بارك الله فيك!',
  'admin.mechanic': 'طريقة اللعب',
  'admin.mechanicPair': 'اضغط بطاقتين متوافقتين',
  'admin.mechanicHunt': 'اضغط كل بطاقة تنطبق عليها القاعدة',
  'admin.density': 'كم من اللوحة ينطبق على القاعدة',
  'admin.densityHelp': 'إن كثُرت فلا شيء يُستبعَد، وإن قلّت فالبحث في فراغ. أقل من النصف بقليل هو الأنسب.',
  'admin.targetProduct': 'حاصل الضرب المطلوب',
  'admin.targetMultiple': 'مضاعفات العدد',
  'admin.targetFactor': 'عوامل العدد',
  'admin.presentation': 'العرض',
  'admin.textSize': 'حجم النص والأرقام',
  'admin.textNormal': 'عادي',
  'admin.textLarge': 'كبير',
  'admin.textHuge': 'أكبر',
  'admin.textProjector': 'شاشة كبيرة / تلفاز',
  'rule.multipleOfUpTo': 'اضغط عددًا وأحد مضاعفاته، حتى × {k}',
  'rule.multiplesOfUpTo': 'اضغط كل مضاعفات {n}، حتى {n} × {k}',
  'msg.overMultiplier': '{b} = {a} × {k} — هذه الجولة حتى × {m} فقط',
  'msg.reshuffled': 'لم تبقَ أزواج، فأُعيد خلط اللوحة',
  'admin.maxMultiplier': 'الضرب حتى',
  'admin.maxMultiplierHelp': 'يُبقي اللوحة ضمن جداول الضرب التي وصل إليها الصف: عند × ٣ يُقبل ٤ ↔ ١٢ ولا يُقبل ٤ ↔ ١٦.',
  'admin.noLimit': 'بلا حدّ',
  'admin.rangeFrom': 'الأرقام من',
  'admin.rangeTo': 'إلى',
  'admin.rangeQuick': 'اختيار سريع',
  'admin.warnSum': 'لا يوجد في هذا المدى عددان مجموعهما {t}، فستخرج بعض البطاقات عنه.',
  'admin.warnProduct': 'لا يوجد في هذا المدى عددان حاصل ضربهما {t}، فسيُستخدم ١ × {t}.',
  'admin.warnMultiple': 'هذا المدى أضيق من أن يتّسع لعدد وضعفه — وسّعه، وإلا خرجت بعض البطاقات عنه.',
  'admin.warnNoMultiples': 'لا توجد مضاعفات للعدد {n} في هذا المدى، فلا شيء للبحث عنه.',
  'admin.warnMultiplesCap': 'مضاعفات {n} حتى × {k} تصل إلى {x}. ارفع أكبر رقم إلى {x} لتظهر كلها.',
  'admin.warnFactors': 'لا توجد عوامل للعدد {n} في هذا المدى، فلا شيء للبحث عنه.',
  'admin.textSizeHelp': 'البطاقات الأكبر تُقرأ من آخر الصف، وعددها الذي يتسع في الهاتف أقل.',
  'admin.multipleDisplay': 'كيف يُعرض الزوج الصحيح في المضاعفات',
  'admin.celebration': 'التشجيع',
  'admin.celebrationSparks': 'شرارات فقط',
  'admin.celebrationWord': 'كلمة تشجيع',
  'admin.celebrationFull': 'احتفال كامل',
  'admin.celebrationHelp': 'شرارات ونغمة، ثم كلمة تشجيع، ثم قصاصات وتصفيق عند التتابع.',
  'admin.decorations': 'رسوم على المظاهر البسيطة',
  'admin.decorationsHelp': 'المسطرة والفرجار والقلم تُرسم في هوامش «الورقة والقلم» كلما تقدّمت الجولة.',
  'admin.puzzle': 'اكشف صورة تحت البطاقات',
  'admin.puzzleHelp': 'الصورة تحتاج لوحة ثابتة، فتبقى الصفوف المكتملة في مكانها ولا تُطوى. ويبقى «أضف صفًا» متاحًا: تُضاف الصفوف الجديدة تحت الصورة.',
  'admin.puzzleScene': 'الصورة',
  'admin.sceneRandom': 'صورة مختلفة كل لوحة',
  'admin.sceneUpload': 'ارفع صورة',
  'admin.sceneRandomHelp': 'كل لوحة تسحب صورة من الصور المدمجة أو من صورك. كل صورة ترفعها تدخل السحب.',
  'media.localOnly': 'تُحفظ في هذا المتصفّح فقط، فتبقى بعد تحديث الصفحة. سجّل الدخول كمعلّم لتحفظها في حسابك وتستخدمها مع الصف.',
  'media.thisBrowser': 'هذا المتصفّح فقط',
  'scene.rocket': 'صاروخ',
  'scene.cat': 'قطّة',
  'scene.boat': 'قارب',
  'scene.tree': 'شجرة',
  'scene.whale': 'حوت',
  'scene.balloon': 'منطاد',
  'curriculum.builtin': 'الصفوف ١–٦ (المدمج)',
  'curriculum.title': 'المنهج',
  'curriculum.subtitle': 'مراحلك وتمارينك أنت. سمِّها، ورتّبها، واحذف ما لا يلزم.',
  'curriculum.mine': 'مناهجك',
  'curriculum.duplicate': 'انسخ المنهج المدمج',
  'curriculum.new': 'ابدأ منهجًا فارغًا',
  'curriculum.readOnly': 'منهج مدمج — انسخه ليصبح لك.',
  'curriculum.addStage': 'أضف مرحلة',
  'curriculum.addLevel': 'أضف تمرينًا',
  'curriculum.stageName': 'اسم المرحلة',
  'curriculum.levelName': 'اسم التمرين',
  'curriculum.countsAs': 'يُحتسب للصف',
  'curriculum.countsAsHelp': 'الأوسمة تُنال على مستوى السنة الدراسية، فالمرحلة المُعاد تسميتها تحتاج أن تقول أي سنة تمثّل.',
  'curriculum.up': 'أعلى',
  'curriculum.down': 'أسفل',
  'curriculum.remove': 'حذف',
  'curriculum.removeStageAsk': 'هل تحذف هذه المرحلة وكل تمارينها؟',
  'curriculum.edit': 'تحرير',
  'curriculum.save': 'احفظ المنهج',
  'curriculum.saved': 'تم الحفظ',
  'curriculum.saving': 'جارٍ الحفظ…',
  'curriculum.name': 'اسم المنهج',
  'curriculum.empty': 'لا مراحل بعد. أضف واحدة، أو انسخ المنهج المدمج.',
  'curriculum.useForClass': 'استخدمه لهذا الصف',
  'curriculum.usingBuiltin': 'هذا الصف يستخدم المنهج المدمج للصفوف ١–٦.',
  'curriculum.deleteAsk': 'هل تحذف هذا المنهج؟ الصفوف التي تستخدمه تعود إلى المنهج المدمج.',
  'curriculum.levels': '{n} تمارين',
  'curriculum.pick': 'اختر التمارين التي ستُلعب في هذه الجلسة، بالترتيب.',
  'media.title': 'صورك وتسجيلاتك',
  'media.subtitle': 'الصور تظهر تحت لوحات الأحجية، والتسجيلات تحلّ محلّ صوت التشجيع في صفوفك.',
  'media.pictures': 'صور الأحجية',
  'media.voices': 'تسجيلات التشجيع',
  'media.upload': 'ارفع ملفًا',
  'media.uploading': 'جارٍ الرفع…',
  'media.none': 'لا ملفات بعد.',
  'media.usage': 'استُخدم {a} من {b}',
  'media.deleteAsk': 'هل تحذف هذا الملف؟',
  'media.err.bad_type': 'نوع الملف غير مقبول.',
  'media.err.too_large': 'الملف كبير جدًا.',
  'media.err.quota_full': 'المساحة ممتلئة — احذف شيئًا أولًا.',
  'media.err.too_many': 'بلغت الحدّ الأقصى لهذا النوع من الملفات.',
  'media.err.generic': 'تعذّر الرفع. أعد المحاولة.',
  'media.voiceHelp': 'مقاطع قصيرة — «أحسنت»، «ممتاز». يُشغَّل أحدها عشوائيًا بعد كل إجابة صحيحة.',
  'media.pictureHelp': 'صورة الصف أو صورة تخصّ الدرس، تُكشف قطعةً قطعةً كلما فرغت اللوحة.',
  'class.of': 'صف {name}',
  'teacher.yourName': 'اسمك',
  'tier.bronze': 'برونزي', 'tier.silver': 'فضّي', 'tier.gold': 'ذهبي',

  'ach.unlocked': 'وسام جديد',
  'ach.points': '+{n} نقطة',

  'trophy.title': 'خزانة الأوسمة',
  'trophy.subtitle': 'كل أوسمة اللعبة، وكم بقي لك على البقية.',
  'trophy.earned': '{a} من {b}',
  'trophy.points': 'نقاط الأوسمة',
  'trophy.streak': 'أيام متتالية',
  'trophy.matches': 'أزواج مطابَقة',
  'trophy.cleared': 'لوحات مكتملة',
  'trophy.rounds': 'جولات لُعبت',
  'trophy.bestCombo': 'أفضل تتابع',
  'trophy.locked': 'مقفل',
  'trophy.progress': '{a} / {b}',
  'trophy.on': 'حصلت عليه في {d}',
  'trophy.reset': 'مسح تقدّمي',
  'trophy.resetAsk': 'هل تريد مسح كل الأوسمة والإحصاءات على هذا الجهاز؟ لا يمكن التراجع.',
  'trophy.days': '{n} أيام',

  'fam.mastery': 'الإتقان',
  'fam.speed': 'السرعة',
  'fam.persistence': 'المواظبة',
  'fam.competition': 'المنافسة',
  'fam.mastery.d': 'تُنال بإتمام ما تبدأه.',
  'fam.speed.d': 'تُنال بالساعة والتتابع.',
  'fam.persistence.d': 'تُنال بالعودة كل يوم.',
  'fam.competition.d': 'تُنال أمام بقية الصف.',

  'ach.title': 'إنجاز',
  'ach.first_clear': 'أول لوحة', 'ach.first_clear.d': 'أكملت أول لوحة لك',
  'ach.perfect_board': 'لوحة مثالية', 'ach.perfect_board.d': 'أكملتها بلا أخطاء',
  'ach.no_add_clear': 'بلا مساعدة', 'ach.no_add_clear.d': 'أكملتها دون إضافة صف',
  'ach.unaided': 'لا يُمَس', 'ach.unaided.d': 'بلا مساعدة ولا إضافة ولا خطأ',
  'ach.grade_ace': 'بطل الصف', 'ach.grade_ace.d': 'أنهيت كل مستويات السنة',
  'ach.quick_off': 'انطلاقة سريعة', 'ach.quick_off.d': 'خمس مطابقات في أول ١٥ ثانية',
  'ach.speed_demon': 'سرعة البرق', 'ach.speed_demon.d': 'أكملت لوحة في أقل من ٣٠ ثانية',
  'ach.combo_5': 'تتابع ×٥', 'ach.combo_5.d': 'خمس مطابقات بلا خطأ',
  'ach.combo_10': 'تتابع ×١٠', 'ach.combo_10.d': 'عشر مطابقات بلا خطأ',
  'ach.combo_20': 'تتابع ×٢٠', 'ach.combo_20.d': 'عشرون مطابقة بلا خطأ',
  'ach.century': 'المئة', 'ach.century.d': '١٠٠ زوج مطابَق إجمالًا',
  'ach.marathon': 'الماراثون', 'ach.marathon.d': '١٠٠٠ زوج مطابَق إجمالًا',
  'ach.regular': 'مواظب', 'ach.regular.d': 'لعبت عشر جولات',
  'ach.streak_3': 'ثلاثة تِباعًا', 'ach.streak_3.d': 'لعبت ثلاثة أيام متتالية',
  'ach.streak_7': 'أسبوع كامل', 'ach.streak_7.d': 'لعبت سبعة أيام متتالية',
  'ach.podium': 'على المنصّة', 'ach.podium.d': 'ضمن الثلاثة الأوائل',
  'ach.champion': 'البطل', 'ach.champion.d': 'الأول على الصف',
  'ach.podium_5': 'خمس منصّات', 'ach.podium_5.d': 'ضمن الثلاثة في خمس جلسات',
  'ach.comeback': 'عودة', 'ach.comeback.d': 'من الأخير إلى الثلاثة الأوائل',
};
